export enum CopilotDabTelemetryEvent {
    CopilotDab_Rendered = 'CopilotDab_Rendered',
    CopilotDab_PopoverOpened = 'CopilotDab_PopoverOpened',
    CopilotDab_ProactiveSuggestionSeen = 'CopilotDab_ProactiveSuggestionSeen',
    CopilotDab_SuggestionClicked = 'CopilotDab_SuggestionClicked',
    CopilotDab_ButtonClicked = 'CopilotDab_ButtonClicked',
}

export const CopilotDabScenario = 'NonFloatingCopilot';

/**
 * Source of a proactive SUA suggestion: 'dynamic' for SLM/OCS-fetched suggestions,
 * 'hardcoded' for the static fallback. Constrained to a union to keep telemetry
 * cardinality bounded.
 */
export type SuggestionSource = 'dynamic' | 'hardcoded';

/**
 * The action_type field from the SUA API response, constrained to the known set
 * of engagement tiers used for score-based selection. Constrained to a union to
 * keep telemetry cardinality bounded.
 */
export type ActionType = 'immediate' | 'direct_response' | 'strategic' | 'creative';

/**
 * These are the official Copilot DAB entrypoints used by the IDEAs dashboards.
 * Additional module-specific entrypoints may be added over time (e.g., Mail / Calendar).
 * But these ones specifically are the ones to represent the canonical set for all-up reporting.
 */
export enum CopilotDabEntrypoint {
    ReadingPane = 'reading_pane',
    MessageList = 'message_list',
    Compose = 'full_compose',
    ForwardCompose = 'forward_compose',
    ReplyReplyAllCompose = 'reply_replyall_compose',
    PopoutReadingPane = 'popout_reading_pane',
    PopoutCompose = 'popout_compose',
    Calendar = 'calendar',
    Newsletters = 'newsletters',

    /**
     * Fallback entrypoint, in case someone adds a new Copilot Dab scenario without updating the
     * entrypoint mapping logic.
     */
    Unknown = 'unknown',
}
